<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      left-side-class="col-xl-4 pb-2"
      :page="headerConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-4 justify-content-end"
    />
    <claim-start-card
      v-if="isclamimStartCardOpen"
      v-model="isAutomatic"
      @cancel="onClose"
      @confirm="onConfirm"
      @is-automatic="onAutomaticChanged"
    />
    <q-tab :active-tab="currentIndexTab" nav-class="text-nowrap">
      <q-tab-item
        :active="!currentIndexTab || currentIndexTab === tabs.Preelegibles"
        lazy
        :tabindex="tabs.Preelegibles"
        title="Servicios Elegibles"
        @click="onActiveTab(tabs.Preelegibles)"
      >
        <filter-manager
          ref="filterRef"
          v-model="filter.model"
          class="mb-4"
          :filters="filtersConfig"
          :open-advanced.sync="shoudDisplayAdvancedFilters"
          @search="onSearchHandler()"
        />
        <div
          class="d-flex justify-content-end align-items-center mb-3 my-pill-theme"
        >
          <div v-if="showChecks" class="mr-2">
            <check-box
              v-model="allChecked"
              checked-bg-color="bg-success"
              class="d-flex justify-content-end text-green"
              icon="fal fa-check"
              :text="allCheckedText"
              @input="checkAll"
            />
          </div>
          <active-dropdown
            v-model="serviceType"
            background-color="#9FAEA7"
            icon="fas fa-chevron-down"
            label-key="label"
            :options="serviceTypes"
            value-key="id"
            @input="onServiceTypeChanged"
          />
        </div>
        <custom-separator class="my-4" text="Resultados" />

        <custom-result-not-found
          v-if="results.length == 0"
          text="No hay información disponible."
        />

        <div v-if="results.length">
          <template v-if="isByService">
            <result-row
              v-for="item in results"
              :key="item.id"
              :checkable="showChecks"
              class="my-3"
              :value="item"
            />
          </template>

          <template v-if="isByServiceLocation">
            <service-location-result-row
              v-for="item in results"
              :key="item.location.id"
              :checkable="showChecks"
              class="my-3"
              :value="item"
              @view-services="onViewServicesHandler"
            />
          </template>

          <template v-if="isByStudent">
            <student-result-row
              v-for="item in results"
              :key="item.id"
              class="my-3"
              :value="item"
              @view-services="onViewServicesHandler"
            />
          </template>

          <pagination
            v-if="showPagination"
            :data="pagination"
            show-text
            @pagination-go-page="onSearchHandler"
          />
        </div>
      </q-tab-item>
      <q-tab-item
        :active="currentIndexTab === tabs.Reclamaciones"
        lazy
        :tabindex="tabs.Reclamaciones"
        title="Reclamaciones"
        @click="onActiveTab(tabs.Reclamaciones)"
      >
        <filter-manager
          ref="filterClaimRef"
          v-model="filter.model"
          class="mb-4"
          :filters="filtersConfigBatch"
          @search="onBatchSearchHandler()"
        />

        <custom-separator class="my-4" text="Resultados" />

        <custom-result-not-found
          v-if="results.length == 0"
          text="No hay información disponible."
        />

        <batch-result-row
          v-for="item in results"
          :key="item.id"
          class="my-3"
          :value="item"
          @refresh="onBatchSearchHandler()"
        />

        <pagination
          v-if="showPagination"
          :data="pagination"
          show-text
          @pagination-go-page="onBatchSearchHandler"
        />
      </q-tab-item>
    </q-tab>
  </div>
</template>

<script>
//mixins
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';

//components
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import CheckBox from 'CheckBox';

//local components
import ActiveDropdown from './components/ActiveDropdown.vue';
import ResultRow from './components/ResultRow.vue';
import BatchResultRow from './components/BatchResultRow.vue';
import ServiceLocationResultRow from './components/ServiceLocationResultRow.vue';
import StudentResultRow from './components/StudentResultRow.vue';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import ClaimStartCard from './components/ClaimStartCard.vue';

//services
import academicYearService from '@/modules/common/academicyear.api';
import { getServiceLocationTypes } from '@/modules/provider/api.js';
import { getFilteredServiceLocations as getServiceLocations } from '@/modules/shared/servicelocation.api.js';
import { getCenters, getMunicipalities } from '@/modules/shared/location.api';
import {
  getByServices,
  getByStudents,
  getByServiceLocation,
  validateService,
  getBatchStatuses,
  createBatch,
  getBatches,
  existsDraftBatchForLocations,
} from '@/modules/medicaid/medicaid-claim.api';
import TABS from '@/utils/constants/claimsTabs';

//constants
const ServiceTypes = Object.freeze({
  SERVICES: 0,
  STUDENT: 1,
  SERVICE_LOCATION: 2,
});

export default {
  name: 'ClaimsMedicaid',
  components: {
    FilterManager,
    PageHeader,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    QTab,
    QTabItem,
    ActiveDropdown,
    ResultRow,
    ServiceLocationResultRow,
    StudentResultRow,
    ClaimStartCard,
    CheckBox,
    BatchResultRow,
  },
  mixins: [storeMixin, alertMixin],
  data() {
    return {
      shoudDisplayAdvancedFilters: false,
      allCheckedIgnoreCallback: false,
      allChecked: false,
      isAutomatic: null,
      isclamimStartCardOpen: false,
      serviceType: ServiceTypes.SERVICES,
      currentIndexTab: TABS.Preelegibles,
      filter: {
        model: {
          academicYear: null,
          studentSieOrName: null,
          center: null,
          municipality: null,
          locationType: null,
          locationService: null,
          consent: null,
          medicalPlan: null,
          batchNumber: null,
          batchStatus: null,
        },
        options: {
          academicYears: [],
          centers: [],
          batchStatuses: [],
          municipalities: [],
          locationTypes: [],
          locationServices: [],
          medicalPlanChoices: [
            { id: true, name: 'Sí' },
            { id: false, name: 'No' },
          ],
          consentChoices: [
            { id: true, name: 'Sí' },
            { id: false, name: 'No' },
          ],
        },
      },
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: 10,
      },
      results: [],
    };
  },
  computed: {
    showChecks() {
      return (
        [false].includes(this.isAutomatic) &&
        (this.isByServiceLocation || this.isByService) &&
        this.results.length > 0
      );
    },
    headerConfig() {
      return {
        title: 'Reclamaciones',
        icon: 'file-circle-exclamation-icon',
        routes: ['Inicio', 'Medicaid', ' Reclamaciones'],
      };
    },
    serviceTypes() {
      return [
        { id: ServiceTypes.SERVICES, label: 'Servicios' },
        { id: ServiceTypes.STUDENT, label: 'Estudiante' },
        { id: ServiceTypes.SERVICE_LOCATION, label: 'Lugar de Servicio' },
      ];
    },
    isByService() {
      return this.serviceType == ServiceTypes.SERVICES;
    },
    isByStudent() {
      return this.serviceType == ServiceTypes.STUDENT;
    },
    isByServiceLocation() {
      return this.serviceType == ServiceTypes.SERVICE_LOCATION;
    },
    tabs() {
      return TABS;
    },
    showPagination() {
      return (
        this.results.length > 0 &&
        this.pagination.totalItemCount > this.pagination.pageSize
      );
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'medicaid' }),
        },
        {
          text: 'Comenzar Reclamación',
          icon: 'fas fa-exclamation-circle',
          visible: this.isClaimStartButtonVisible,
          variant: 'success',
          click: () => {
            if (!this.filter.model.academicYear) {
              this.showError(
                'Debe seleccionar un año académico para continuar'
              );
              return;
            }
            this.isclamimStartCardOpen = true;
          },
        },
        {
          text: 'Actualizar Servicios',
          icon: 'fas fa-sync',
          visible: this.canValidateService,
          variant: 'success',
          click: () => {
            this.validateService();
          },
        },
      ];
    },
    isClaimStartButtonVisible() {
      return (
        !this.isclamimStartCardOpen &&
        (this.isByServiceLocation || this.isByService) &&
        this.results.length > 0 &&
        TABS.Preelegibles === this.currentIndexTab
      );
    },
    canValidateService() {
      return this.userHasPermissions('provider.medicaid.claims.validate');
    },
    allCheckedText() {
      return this.allChecked
        ? `Deseleccionar (${this.results.filter((x) => x.checked).length})`
        : `Seleccionar  (${this.results.filter((x) => x.checked).length})`;
    },
    anyChecked() {
      return this.results.some((x) => x.checked);
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          value: this.filter.model.academicYear,
          options: this.filter.options.academicYears,
          placeholder: 'Año Académico',
          class: 'col-12 col-md-6',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          disabled: this.filter.options.academicYears?.length === 1,
          onChanged: this.onChangeAcademicYearHandler,
          validations: 'required',
          clearModelsOnUpdate: [
            'center',
            'municipality',
            'locationType',
            'locationService',
          ],
        },
        {
          name: 'studentSieOrName',
          component: 'CustomInput',
          value: this.filter.model.studentSieOrName,
          placeholder: 'SIE o Nombre de Estudiante',
          class: 'col-12 col-md-6',
          clearable: true,
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          value: this.filter.model.center,
          options: this.filter.options.centers,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.centers?.length === 1,
          onChanged: this.onChangeCenterHandler,
          clearModelsOnUpdate: ['municipality'],
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          value: this.filter.model.municipality,
          options: this.filter.options.municipalities,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.municipalities?.length === 1,
          onChanged: this.onChangeMunicipalityHandler,
          clearModelsOnUpdate: ['locationService'],
        },

        {
          name: 'locationType',
          label: 'Tipo de lugar:',
          component: 'CustomDropDown',
          value: this.filter.model.locationType,
          options: this.filter.options.locationTypes,
          visible: !this.selectTrasportation,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3 d-flex flex-column',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.locationTypes?.length === 1,
          onChanged: this.getLocations,
          clearModelsOnUpdate: ['locationService'],
        },

        {
          name: 'locationService',
          label: 'Lugar de Servicio:',
          component: 'CustomDropDown',
          value: this.filter.model.locationService,
          options: this.filter.options.locationServices,
          visible: !this.selectTrasportation,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3 d-flex flex-column',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.locationServices?.length === 1,
        },
        {
          name: 'consent',
          label: 'Consentimiento:',
          component: 'CustomDropDown',
          value: this.filter.model.consent,
          options: this.filter.options.consentChoices,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'medicalPlan',
          label: 'Plan Médico:',
          component: 'CustomDropDown',
          value: this.filter.model.medicalPlan,
          options: this.filter.options.medicalPlanChoices,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
      ];
    },
    filtersConfigBatch() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          value: this.filter.model.academicYear,
          options: this.filter.options.academicYears,
          placeholder: 'Año Académico',
          class: 'col-12 col-md-4',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          disabled: this.filter.options.academicYears?.length === 1,
          onChanged: this.onChangeAcademicYearHandler,
          validations: 'required',
          clearModelsOnUpdate: [
            'center',
            'municipality',
            'locationType',
            'locationService',
          ],
        },
        {
          name: 'batchStatus',
          component: 'CustomDropDown',
          value: this.filter.model.batchStatus,
          options: this.filter.options.batchStatuses,
          placeholder: 'Estatus',
          class: 'col-12 col-md-4',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
        {
          name: 'batchNumber',
          component: 'CustomInput',
          value: this.filter.model.batchNumber,
          placeholder: 'Número de Batch',
          class: 'col-12 col-md-4',
          clearable: true,
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          value: this.filter.model.center,
          options: this.filter.options.centers,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.centers?.length === 1,
          onChanged: this.onChangeCenterHandler,
          clearModelsOnUpdate: ['municipality'],
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          value: this.filter.model.municipality,
          options: this.filter.options.municipalities,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.municipalities?.length === 1,
          onChanged: this.onChangeMunicipalityHandler,
          clearModelsOnUpdate: ['locationService'],
        },

        {
          name: 'locationType',
          label: 'Tipo de lugar:',
          component: 'CustomDropDown',
          value: this.filter.model.locationType,
          options: this.filter.options.locationTypes,
          visible: !this.selectTrasportation,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3 d-flex flex-column',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.locationTypes?.length === 1,
          onChanged: this.getLocations,
          clearModelsOnUpdate: ['locationService'],
        },

        {
          name: 'locationService',
          label: 'Lugar de Servicio:',
          component: 'CustomDropDown',
          value: this.filter.model.locationService,
          options: this.filter.options.locationServices,
          visible: !this.selectTrasportation,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3 d-flex flex-column',
          clearable: true,
          isAdvanced: true,
          disabled: this.filter.options.locationServices?.length === 1,
        },
      ];
    },
  },
  async created() {
    await this.init();
    this.currentIndexTab = Number(this.$route.query.tab ?? TABS.Preelegibles);
  },
  methods: {
    async init() {
      await this.getAcademicYears();
      await this.getServiceLocationTypes();
      await this.getBatchStatuses();
    },
    async getBatchStatuses() {
      const { data } = await getBatchStatuses();
      this.filter.options.batchStatuses = data;
    },
    onActiveTab(indexTab) {
      this.results = [];
      const same = this.currentIndexTab === Number(indexTab);
      if (same) return;

      this.currentIndexTab = Number(indexTab);

      const payload = indexTab
        ? { query: { tab: indexTab } }
        : { name: this.$route.name };
      this.$router.replace(payload);
    },
    onAutomaticChanged(value) {
      if (!value) {
        this.shoudDisplayAdvancedFilters = true;
        this.filter.model.medicalPlan = this.filter.options.medicalPlanChoices.find(
          (x) => x.id === true
        );
        this.filter.model.consent = this.filter.options.consentChoices.find(
          (x) => x.id === true
        );
        this.onSearchHandler();
      }
    },
    async getAcademicYears() {
      const academicYears = await academicYearService.getRegistryVisit();
      this.filter.options.academicYears = academicYears;
      this.filter.model.academicYear = this.currentAcademicYear();

      if (this.filter.model.academicYear)
        await this.onChangeAcademicYearHandler();
    },
    checkAll() {
      if (this.allCheckedIgnoreCallback) return;
      this.results.forEach((x) => (x.checked = this.allChecked));
    },
    onCheckItem({ checked }) {
      if (checked) {
        const every = this.results.every((x) => x.checked);
        if (every) this.allChecked = true;
      } else if (this.allChecked) {
        this.allCheckedIgnoreCallback = true;
        this.allChecked = false;
        setTimeout(() => (this.allCheckedIgnoreCallback = false), 100);
      }
    },
    async onChangeAcademicYearHandler() {
      this.filter.options.municipalities = [];
      this.filter.options.locationServices = [];
      this.filter.options.centers = [];

      if (!this.filter.model.academicYear) return;

      const { data } = await getCenters({
        academicYearId: this.filter.model.academicYear.id,
      });

      this.filter.options.centers = data;

      if (data?.length === 1) {
        this.filter.model.center = {
          ...data[0],
          disabled: true,
        };
        await this.onChangeCenterHandler();
      }
    },
    onClose() {
      this.isAutomatic = null;
      this.isclamimStartCardOpen = false;
      this.results.forEach((x) => (x.checked = false));
      this.allChecked = false;
    },
    async onConfirm() {
      if (!this.isAutomatic && !this.anyChecked) {
        const message =
          this.isAutomatic === null
            ? 'Debe seleccionar una opción.'
            : 'Debe seleccionar al menos un servicio para enviar a reclamación.';
        this.ShowToast('Atención', message, 'error');
        return;
      }
      const message = this.isAutomatic
        ? `¿Está seguro que desea enviar de manera automática todos los servicios elegibles a reclamación?`
        : `¿Está seguro que desea enviar a reclamar los ${
            this.results.filter((x) => x.checked).length
          } servicio(s) seleccionado(s)?`;

      const confirmation = await this.ShowCancelModal(
        'Confirmación',
        message,
        'Si',
        'No'
      );

      if (!confirmation) return;
      try {
        const ids =
          this.serviceType === ServiceTypes.SERVICES
            ? this.results.filter((x) => x.checked).map((x) => x.id)
            : null;
        const locationIds =
          this.serviceType === ServiceTypes.SERVICE_LOCATION
            ? this.results.filter((x) => x.checked).map((x) => x.location.id)
            : null;

        const confirmationMessage = this.isAutomatic
          ? 'Existe(n) Batch(es) en estatus Borrador para Lugar(es) de Servicio(s) seleccionado(s). Los registros se enviarán al batch creado. ¿Está seguro que desea enviar a reclamar los todos servicio(s)?'
          : `Existe(n) Batch(es) en estatus Borrador para Lugar(es) de Servicio(s) seleccionado(s). Los registros se enviarán al batch creado.
              ¿Está seguro que desea enviar a reclamar los ${
                this.results.filter((x) => x.checked).length
              } servicio(s) seleccionado(s)?`;

        const existsDraftBatch = await this.existsDraftBatchForLocations();

        if (existsDraftBatch) {
          const confirmation = await this.ShowCancelModal(
            'Confirmación',
            confirmationMessage,
            'Si',
            'No'
          );
          if (!confirmation) return;
        }

        await createBatch({
          academicYearId: this.filter.model.academicYear.id,
          ids,
          locationIds,
          type: this.serviceType,
          isManual: !this.isAutomatic,
        });
      } catch (error) {
        this.ShowToast('', error.response.data.message, 'error');
        return;
      }

      this.ShowToast(
        'Éxito',
        this.isAutomatic
          ? 'Los registros fueron enviados a reclamación automáticamente de forma exitosa.'
          : 'Los registros seleccionados fueron enviados a reclamación de forma exitosa.',
        'success'
      );

      this.onSearchHandler();

      this.onClose();
    },
    async getServiceLocationTypes() {
      const { data } = await getServiceLocationTypes();
      this.filter.options.locationTypes = data;
      if (data?.length === 1) {
        this.filter.model.locationType = data[0];
        await this.getLocations();
      }
    },
    async getLocations() {
      if (
        this.filter.model.locationType &&
        this.filter.model.academicYear &&
        this.filter.model.center &&
        this.filter.model.municipality
      ) {
        const { data } = await getServiceLocations({
          fiscalYearId: this.filter.model.academicYear?.id,
          centerId: this.filter.model.center?.id,
          municipalityId: this.filter.model.municipality?.id,
          type: this.filter.model.locationType?.id,
        });
        this.filter.options.locationServices = data;
        if (data?.length === 1) this.filter.model.locationService = data[0];
      } else {
        this.filter.options.locationServices = [];
      }
    },
    async onChangeCenterHandler() {
      this.filter.model.municipality = null;
      if (this.filter.model.center) {
        const { data } = await getMunicipalities({
          academicYearId: this.filter.model.academicYear?.id,
          centerId: this.filter.model.center.id,
        });

        this.filter.options = {
          ...this.filter.options,
          municipalities: data,
        };

        if (data?.length === 1) {
          this.filter.model.municipality = {
            ...data[0],
          };
        }
        await this.getLocations();
      } else {
        this.filter.options.municipalities = [];
        this.filter.options.locationServices = [];
      }
    },
    onChangeMunicipalityHandler() {
      this.filter.options.locationServices = [];
    },
    search(params) {
      switch (this.serviceType) {
        case ServiceTypes.SERVICES:
          return getByServices(params);
        case ServiceTypes.STUDENT:
          return getByStudents(params);
        case ServiceTypes.SERVICE_LOCATION:
          return getByServiceLocation(params);
      }
    },
    onServiceTypeChanged() {
      this.onClose();
      this.results = [];
    },
    async onSearchHandler(page = 1) {
      this.pagination.currentPage = page;

      const params = {
        academicYearId: this.filter.model.academicYear?.id,
        studentSieOrName: this.filter.model.studentSieOrName,
        centerId: this.filter.model.center?.id,
        municipalityId: this.filter.model.municipality?.id,
        locationTypeId: this.filter.model.locationType?.id,
        locationServiceId: this.filter.model.locationService?.id,
        hasConsent: this.filter.model.consent?.id,
        hasMedicalPlan: this.filter.model.medicalPlan?.id,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      const { data: results = { data: [] } } = await this.search(params).catch(
        () => {
          this.showError('Ocurrió un error al obtener los resultados');
          return { data: { data: [] } };
        }
      );
      this.results = results.data.map((x) => ({
        ...x,
        checked: false,
        opened: false,
      }));

      this.pagination = {
        ...this.pagination,
        totalItemCount: results.totalItemCount,
        pageCount: results.pageCount,
        currentPage: results.currentPage,
        count: results.count,
      };
    },
    async existsDraftBatchForLocations() {
      const selected = this.results.filter((x) => x.checked);

      const locationIds = [...new Set(selected.map((x) => x.location?.id))];
      try {
        const payload = {
          academicYearId: this.filter.model.academicYear?.id,
          locationIds,
          isManual: !this.isAutomatic,
        };
        const { data } = await existsDraftBatchForLocations(payload);
        return data;
      } catch (error) {
        this.showError('Ocurrió un error al validar los lotes en borrador');
        return false;
      }
    },
    async onBatchSearchHandler(page = 1) {
      this.pagination.currentPage = page;

      const params = {
        academicYearId: this.filter.model.academicYear?.id,
        number: this.filter.model.batchNumber,
        statusId: this.filter.model.batchStatus?.id,
        centerId: this.filter.model.center?.id,
        municipalityId: this.filter.model.municipality?.id,
        locationTypeId: this.filter.model.locationType?.id,
        locationServiceId: this.filter.model.locationService?.id,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      const { data: results = { data: [] } } = await getBatches(params).catch(
        () => {
          this.showError('Ocurrió un error al obtener los resultados');
          return { data: { data: [] } };
        }
      );
      this.results = results.data.map((x) => ({
        ...x,
        checked: false,
        opened: false,
      }));

      this.pagination = {
        ...this.pagination,
        totalItemCount: results.totalItemCount,
        pageCount: results.pageCount,
        currentPage: results.currentPage,
        count: results.count,
      };
    },
    async onViewServicesHandler({
      studentSieId,
      isAdvancedSearch,
      center,
      location,
      locationType,
      municipality,
    }) {
      this.results = [];
      this.serviceType = ServiceTypes.SERVICES;
      this.filter.model.studentSieOrName = studentSieId ?? null;
      if (isAdvancedSearch) {
        this.shoudDisplayAdvancedFilters = isAdvancedSearch;
        this.filter.model.center = center;
        await this.onChangeCenterHandler();
        this.filter.model.municipality = municipality;
        this.filter.model.locationType = locationType;
        await this.getLocations();
        this.filter.model.locationService = location;
      }
      this.onSearchHandler();
    },
    async validateService() {
      let confirmation = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea actualizar la bandeja?',
        'Si',
        'No'
      );

      if (!confirmation) return;

      await validateService(this.filter.model.academicYear?.id);

      this.ShowToast(
        'Éxito',
        'El proceso de actualización de servicios elegibles para reclamación se ha ejecutado exitosamente.',
        'success'
      );
    },
  },
};
</script>
<style scoped>
::v-deep .orange-icon {
  font-size: 18pt;
}
.my-pill-theme ::v-deep .service-pill {
  --icon-bg: #3f5b60;
  --icon-fg: #9faea7;
}
</style>
